import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ParkingsService, UsersService } from '../../service';
import { Statistics, UserStatistics, Parking } from '../../entity';
import { Observable } from "rxjs";
import { IParking } from "../../entity/parking";
import { IParkingLotGroup } from "../../entity/parking-lot";

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
})
export class DashboardComponent implements OnInit {
    paymentStatistics: Array<Statistics>;
    userStatistics: Array<UserStatistics>;

    parkings$: Observable<IParking[]>;
    parkingLots$: Observable<IParkingLotGroup[]>;

    constructor(
        private router: Router,
        private parkingsService: ParkingsService,
        private usersService: UsersService
    ) { }

    ngOnInit() {
        this.refresh();
    }

    refresh() {
        const today = new Date();
        const startDate = new Date(today.getFullYear(), 0, 1, 0, 0, 0).toISOString();
        const endDate = new Date(today.getFullYear(), 11, 31, 0, 0, 0).toISOString();
        const dateRange = {
            startDate: startDate,
            endDate: endDate
        };

        this.parkings$ = this.parkingsService.query();
        this.parkingLots$ = this.parkingsService.queryLotsGrouped();

        this.usersService.getUserStatistics(dateRange).subscribe(data => {
            const userStatistics = new Array<UserStatistics>();
            data.forEach(item => {
                const userStatistic = new UserStatistics();
                userStatistic.fromObject(item);

                userStatistics.push(userStatistic);
            });
            this.userStatistics = userStatistics;
        });
    }

    addparkinglot() {
        this.router.navigate(['/parking-lots/add-lot']);
    }
}
